import angular from 'angular';
import DynamicLinkService from './dynamicLink.service.js';
import DynamicLinkSchema from './dynamicLink.schema.js';

let dynamicLinkModule = angular.module('dynamicLink', [])

    .service('DynamicLinkService', DynamicLinkService)
    .constant('DynamicLinkSchema', DynamicLinkSchema)
    .name;

export default dynamicLinkModule;
